// Shared by the class and the Sentry-suppress meta on
// useChangePassword, so the two can never drift out of sync.
export const CLERK_PASSWORD_VALIDATION_ERROR_NAME =
  'ClerkPasswordValidationError';

/**
 * Expected Clerk password validation failure shown inline at
 * the change-password form — breached/compromised password,
 * wrong current password, policy rejection. Named so the global
 * MutationCache skips it from Sentry via
 * `meta.suppressSentryErrorNames` (PORTAL-191). Unexpected
 * failures (network, session) stay plain `Error`s and report.
 */
export class ClerkPasswordValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = CLERK_PASSWORD_VALIDATION_ERROR_NAME;
  }
}
